// extracted by mini-css-extract-plugin
export var actionButton = "_74-0";
export var attachmentLine = "_74-1";
export var fileInput = "_74-2";
export var fileUploadWrapper = "_74-4";
export var footer = "_74-3";
export var modalContent = "_74-5";
export var paperclip = "_74-6";
export var quillEditor = "_74-7";